import { AdditionalInfoRepo } from '../../../store/additional-info-store/additional-info-store.js';

export class AdditionalInfoController {
  constructor(host) {
    this.additionalInfo = [];
    this.additionalInfoHandler = this.onChange.bind(this);
    this.additionalInfoRepo = new AdditionalInfoRepo();
    this.additionalInfoSub = null;
    (this.host = host).addController(this);
  }

  onChange(additionalInfo) {
    this.additionalInfo = additionalInfo;
    this.host.requestUpdate();
  }

  hostConnected() {
    if (!this.additionalInfoSub) {
      this.additionalInfoSub =
        this.additionalInfoRepo.additionalInfo$.subscribe(
          this.additionalInfoHandler
        );
    }
  }

  hostDisconnected() {
    if (this.additionalInfoSub) {
      this.additionalInfoSub.unsubscribe();
      this.additionalInfoSub = null;
    }
  }
}
